<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Data Peserta
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <CCardBody>
      <CRow>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3 pr-xl-4 pr-sm-0">
          <!-- Tabs -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Profile Settings</h5>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-diri/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Diri</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-anggota/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Anggota</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/keanggotaan/data-anggota/data-dokumen/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                  style="color:#2F3AAA;font-weight:bold"
                >Data Dokumen Pendukung</router-link>
              </li>
            </ul>
          </div>
          <!-- <button
            type="button"
            class="btn btn-success btn-block btn-md text-white text-bold"
            @click="modalVerif = true"
          >
            <i class="fa fa-paper-plane" aria-hidden="true"></i> verifikasi
          </button>
          <button
            type="button"
            class="btn btn-warning btn-block btn-md text-white text-bold"
            @click="modalEmail = true"
          >
            <i class="fa fa-envelope" aria-hidden="true"></i> Kirim Email
          </button>
          <p class="text-danger font-weight-bold text-center mt-2">Status : Data Belum Terverifikasi</p>-->
        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mt-3">
          <!-- small box -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Data Dokumen Pendukung</h5>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Nama File</th>
                      <th>Status Dokumen</th>
                      <th>Status</th>
                      <th class="text-center" colspan="2">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value , index) in dokumenPeserta" v-bind:key="index">
                      <td>{{ index+1 }}</td>
                      <td
                        class="w-50 w-sm-100 text-uppercase"
                        style="text-align:left"
                      >{{ value.namaDokumen }}</td>
                      <td 
                        class="font-weight-bold text-left"
                        :class="{
                          'text-success': value.statusRequired == '1',
                          'text-danger': value.statusRequired == '0',
                        }"
                      >
                        {{ value.statusRequired == '1' ? 'Wajib' : 'Tidak Wajib' }}
                      </td>                   
                      <td
                        class="font-weight-bold text-secondary"
                        v-if="value.statusUpload == '0'"
                      >Belum Upload</td>
                      <td
                        class="font-weight-bold text-success"
                        v-if="value.statusUpload ==   '1'"
                      >Terverifikasi</td>
                      <td
                        class="font-weight-bold text-primary"
                        v-if="value.statusUpload ==   '2'"
                      >Sudah Upload</td>
                      <td
                        class="font-weight-bold text-info"
                        v-if="value.statusUpload ==      '3'"
                      >File Tidak Terbaca</td>
                      <td
                        class="font-weight-bold text-danger"
                        v-if="value.statusUpload ==    '4'"
                      >File Tidak Sesuai</td>
                      <td class="text-center">
                        <button
                          class="btn btn-info text-light p-0 px-3 shadow mx-auto"
                          :disabled="value.statusUpload == '0'"
                          v-c-tooltip="'Verifikasi'"
                          @click="verifikasiDokumen(value.idDokumenPendukungPeserta,value.statusUpload)"
                        >
                          <small><small><i class="fa fa-check"  ></i></small></small>
                        </button>
                      </td>
                      <td class="text-center" style="display:none">
                        <button class="btn btn-success text-light p-0 px-3 shadow mx-auto">
                          <small>Upload</small>
                        </button>
                      </td>
                      <td class="text-center">
                        <button
                          class="btn btn-warning text-light p-0 px-3 shadow mx-auto"
                          :disabled="value.statusUpload == '0' "
                          v-c-tooltip="'Lihat File'"
                          @click="bukaFile(value.file)"
                        >
                  
                          <small><i class="fa fa-eye"  ></i></small>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-right">
                <button class="btn btn-md btn-success mt-5">Update</button>
              </div>
            </div>
          </div>
        </div>
      </CRow>
      <!-- Modal Verifikasi -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
        size="md"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <select name="id_outlet" v-model="formData.statusUpload" class="form-control mb-2">
                <option value="0" :selected="formData.statusUpload == '0'">Belum Upload</option>
                <option value="1" :selected="formData.statusUpload == '1'">Terverifikasi</option>
                <option value="2" :selected="formData.statusUpload == '2'">Sudah Upload</option>
                <option value="3" :selected="formData.statusUpload == '3'">File Tidak Terbaca</option>
                <option value="4" :selected="formData.statusUpload == '4'">File Tidak Sesuai</option>
              </select>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Data Dokumen Pendukung</h6>          
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <CModal
        title="Modal title"
        :show.sync="modalEmail"
        :no-close-on-backdrop="true"
        :centered="true"
        size="md"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Subjek" placeholder="Masukkan Subjek" />
            </CCol>
            <CCol sm="12">
              <CTextarea
                class="font-weight-bold"
                label="Pesan"
                rows="3"
                placeholder="Masukkan isi pesan"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <input type="file" class="custom-file-input" id="validatedCustomFile" />
                <label class="custom-file-label" for="validatedCustomFile">{{ fileName }}.</label>
                <label class="custom-file-label" for="validatedCustomFile">Choose file</label>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>          
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>
<script>
import DataKeanggotaanService from "../../../services/keanggotaan/data-anggota.service";

export default {
  name: "DataDokumen",
  el: "#app",
  data() {
    return {
      // fileName: "Choose File...",
      details: {},
      masterDokumen: [],
      dokumenPeserta: [],
      formData: {
        idDokumenPendukungPeserta: "",
        statusUpload: "",
        verifikasiPada: new Date().toISOString().slice(0, 10)
      },
      no: 1,
      status: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      index: 0,
      content: []
    };
  },
  mounted() {
    this.getData();
    this.formData.idUser = this.$route.params.id_user;
  },
  methods: {
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    bukaFile(file) {
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        this.$baseUrlFoUser + "data_dokumen_pendukung/" + file,
        file,
        params
      );
    },
    updateDataAnggota() {
      DataKeanggotaanService.updateDataAnggota(
        this.$route.params.id_user,
        this.details
      )
        .then(response => {
          // comment console console.log(response);
          this.alertSuccess();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },
    verifikasiDokumen(idDokumenPendukungPeserta, statusUpload, index) {
      this.modalVerif = true;
      this.formData.idDokumenPendukungPeserta = idDokumenPendukungPeserta;
      this.formData.statusUpload = statusUpload;
      this.index = index;
    },

    getData() {
      DataKeanggotaanService.getDokumenPendukungPeserta(
        this.$route.params.id_user
      )
        .then(response => {
          this.dokumenPeserta = response.data.data;
          // comment console console.log(response);
        })
        .catch(error => {
          // comment console console.log(error);
        });

      // comment console console.log("data data data");
      // comment console console.log("sdf" + vm.masterDokumen);

      // var arr1 = this.content[0];
      // var arr2 = this.content[1];
      // // comment console console.log("array baru"+arr1)
    },

    postData() {
      var vm = this;
      DataKeanggotaanService.verifikasiDataDokumen(this.formData)
        .then(response => {
          // comment console console.log(response);
          this.modalVerif = false;
          this.alertVerif();
          vm.getData();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    }
  }
};
</script>
